import { render, staticRenderFns } from "./ReportMealsTabMealEmployee.vue?vue&type=template&id=126fa8a7"
import script from "./ReportMealsTabMealEmployee.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabMealEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports